/* eslint-disable react-hooks/exhaustive-deps */
import useFetch from '@hooks/useFetch';
import { HOST_TYPE } from '@utils/api-helper/host';

const useGoalBenefits = (
  goalBenefitsKey,
  options = { selector: null, fallbackData: undefined }
) => {
  const key = `api/goal-benefits/${goalBenefitsKey}`;

  const {
    data: goalBenefits,
    isValidating,
    ...rest
  } = useFetch(
    goalBenefitsKey ? key : null,
    { useCamelCase: false, hostType: HOST_TYPE.CMS },
    { fallbackData: options.fallbackData }
  );

  if (options.selector && typeof options.selector === 'function')
    return options.selector(goalBenefits || {});
  return {
    key,
    goalBenefits,
    isValidating,
    ...rest
  };
};

export default useGoalBenefits;
